import { Project, AnalyzeType } from "../../../../@types/projects/types";
import { DEFAULT_RESULTS_CURVE_POINTS } from "../../../utils/curveGeneration";
import {
  SystemSaturationCalculationStrategy,
  LiaoSystemSaturationCalculationStrategy,
  LambdaSystemSaturationCalculationStrategy
} from "../strategies";

export class SystemSaturationCalculator {
  private strategies: Map<AnalyzeType, SystemSaturationCalculationStrategy>;

  constructor() {
    this.strategies = new Map();
    this.strategies.set(AnalyzeType.LIAO, new LiaoSystemSaturationCalculationStrategy());
    this.strategies.set(AnalyzeType.LAMBDA, new LambdaSystemSaturationCalculationStrategy());
  }

  /**
   * Executes the calculation for a given project and analysis type.
   * @param project The project object to be processed.
   * @param type The type of analysis to determine the calculation strategy.
   * @returns The project with the calculated data.
   */
  public calculate(project: Project, type: AnalyzeType, numberOfPoints: number = DEFAULT_RESULTS_CURVE_POINTS): Project {
    const strategy = this.strategies.get(type);

    if (!strategy) {
      throw new Error(`Nenhuma estratégia de cálculo encontrada para o tipo: ${type}`);
    }

    return strategy.calculate(project, numberOfPoints);
  }

  public calculateBoth(project: Project, numberOfPoints: number = DEFAULT_RESULTS_CURVE_POINTS): Project {
    const liao = this.strategies.get(AnalyzeType.LIAO)!;
    const lambda = this.strategies.get(AnalyzeType.LAMBDA)!;
    liao.calculate(project, numberOfPoints);
    lambda.calculate(project, numberOfPoints);
    return project;
  }
}
